<!--@format-->
<template>
    <div :class="['contact-field-hider-widget']">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Hide/Show Contact Fields</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="bordered-container">
                    <div class="title">These changes will apply to all contact pages.</div>
                </div>

                <app-border-section topText="Contact Information">
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.address">
                            <template>
                                <n24-location-outline
                                    class="svg"
                                    :style="{ opacity: contact.shownConfig.address ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="contact.shownConfig.address ? 'selected' : 'unselected'"
                                >
                                    Address
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.email">
                            <template>
                                <k5-email-outline-svg
                                    color="#382153"
                                    :style="{ opacity: contact.shownConfig.email ? 1 : 0.3 }"
                                    class="svg"
                                />
                                <span
                                    class="button-label"
                                    :class="contact.shownConfig.email ? 'selected' : 'unselected'"
                                >
                                    Email
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.workPhone">
                            <template>
                                <g5-call-outline-svg
                                    class="svg"
                                    :style="{ opacity: contact.shownConfig.workPhone ? 1 : 0.3 }"
                                    color="#382153"
                                />
                                <span
                                    class="button-label"
                                    :class="
                                        contact.shownConfig.workPhone ? 'selected' : 'unselected'
                                    "
                                >
                                    Work Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.mobilePhone">
                            <template>
                                <f18-mobile-outline-svg
                                    :style="{ opacity: contact.shownConfig.mobilePhone ? 1 : 0.3 }"
                                    class="svg"
                                />
                                <span
                                    class="button-label"
                                    :class="
                                        contact.shownConfig.mobilePhone ? 'selected' : 'unselected'
                                    "
                                >
                                    Mobile Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.teamsPhone">
                            <template>
                                <j24-teams-logo-outline-svg
                                    class="svg"
                                    :style="{ opacity: contact.shownConfig.teamsPhone ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="
                                        contact.shownConfig.teamsPhone ? 'selected' : 'unselected'
                                    "
                                >
                                    Teams Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="contact.shownConfig.homePhone">
                            <template>
                                <g24-home-outline-svg
                                    color="#382153"
                                    :style="{ opacity: contact.shownConfig.homePhone ? 1 : 0.3 }"
                                    class="svg"
                                />
                                <span
                                    class="button-label"
                                    :class="
                                        contact.shownConfig.homePhone ? 'selected' : 'unselected'
                                    "
                                >
                                    Home Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                </app-border-section>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="saveHiddenFields"> Save </app-button>
                </div>
            </div>

            <br />
        </div>
    </div>
</template>

<script>
const AgencyUsersSearch = () => import('@/components/client/agency-users-search.vue');
const AppButton = () => import('@/components/common/app-button.vue');
const AppDatePicker = () => import('@/components/common/app-date-picker');
const AppInput = () => import('@/components/common/app-input.vue');
const AppTextArea = () => import('@/components/common/app-textarea');
const AppSwitch = () => import('@/components/common/app-switch');
const CompanyLocations = () => import('@/components/company/company-locations.vue');
const CompanyTypesDropdown = () => import('@/components/company/company-types-dropdown');
const CustomFieldDesignElement = () =>
    import('@/components/custom-field/custom-field-design-element');
const ImageUpload = () => import('@/components/common/image-upload.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const Multiselect = () => import('vue-multiselect');
const O6AddSvg = () => import('@/components/svg/grid/o6-add-svg');
const QuickAddScrubbingSvg = () => import('@/components/svg/quick-add/quick-add-scrubbing-svg.vue');
const S3CloseSvg = () => import('@/components/svg/grid/s3-close-svg');
const ServiceDropdown = () => import('@/components/service/service-dropdown');
const VerticalDropdown = () => import('@/components/vertical/vertical-dropdown');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppBorderSection = () => import('@/components/common/app-border-section');
const N24LocationOutlineSvg = () => import('@/components/svg/grid/n24-location-outline-svg');
const K5EmailOutlineSvg = () => import('@/components/svg/grid/k5-email-outline-svg');
const G5CallOutlineSvg = () => import('@/components/svg/grid/g5-call-outline-svg');
const F18MobileOutlineSvg = () => import('@/components/svg/grid/f18-mobile-outline-svg');
const J24TeamsLogoOutlineSvg = () => import('@/components/svg/grid/j24-teams-logo-outline-svg');
const G24HomeOutline = () => import('@/components/svg/grid/g24-home-outline-svg');

import { CustomFieldsServiceMixin } from '@/mixins/custom-fields-service-mixin';
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'contact-field-hider-widget',

    components: {
        'agency-users-search': AgencyUsersSearch,
        'app-button': AppButton,
        'app-date-picker': AppDatePicker,
        'app-input': AppInput,
        'app-text-area': AppTextArea,
        'app-switch': AppSwitch,
        'company-locations': CompanyLocations,
        'company-types-dropdown': CompanyTypesDropdown,
        'custom-field-design-element': CustomFieldDesignElement,
        'image-upload': ImageUpload,
        'loading-screen-svg': LoadingScreenSvg,
        multiselect: Multiselect,
        'o6-add-svg': O6AddSvg,
        'quick-add-company-svg': QuickAddScrubbingSvg,
        's3-close-svg': S3CloseSvg,
        'service-dropdown': ServiceDropdown,
        'vertical-dropdown': VerticalDropdown,
        'widget-close-svg': WidgetCloseSvg,
        'app-border-section': AppBorderSection,
        'n24-location-outline': N24LocationOutlineSvg,
        'k5-email-outline-svg': K5EmailOutlineSvg,
        'g5-call-outline-svg': G5CallOutlineSvg,
        'f18-mobile-outline-svg': F18MobileOutlineSvg,
        'j24-teams-logo-outline-svg': J24TeamsLogoOutlineSvg,
        'g24-home-outline-svg': G24HomeOutline,
    },

    mixins: [CustomFieldsServiceMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            contact: {
                shownConfig: {
                    address: true,
                    email: true,
                    workPhone: true,
                    mobilePhone: true,
                    teamsPhone: true,
                    homePhone: true,
                },
            },
        };
    },

    created() {
        this.getHiddenConfig();
    },

    methods: {
        getHiddenConfig() {
            this.$api
                .get('/ms/configs/v1/users?where=[{"Type": {"$eq": "contact-shown-fields"}}]')
                .then((response) => {
                    if (response.data.data.length > 0) {
                        var res = JSON.parse(response.data.data[0].Config);
                        if (res) {
                            this.contact.shownConfig = res;
                        }
                    }
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        saveHiddenFields() {
            var payload = {
                Type: 'contact-shown-fields',
                Config: JSON.stringify(this.contact.shownConfig),
            };

            this.$api
                .post('/ms/configs/v1/users', payload)
                .then(() => {
                    EventBus.$emit('user-config:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred saving your settings', { error });
                });
        },
    },
};
</script>

<style>
.contact-field-hider-widget .input-container {
    position: relative;
}

.contact-field-hider-widget .button-label {
    font-size: 16px;
}

.contact-field-hider-widget .svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
}

.contact-field-hider-widget .bordered-container {
    margin-top: -21px;
    padding-bottom: 31px;
}

.contact-field-hider-widget .app-switch {
    padding-bottom: 30px;
}

.contact-field-hider-widget .app-switch .app-switch-label {
    display: flex;
    align-items: center;
}

.contact-field-hider-widget .action-container {
    display: flex;
}

.contact-field-hider-widget .app-border-section {
    margin-bottom: 32px;
}

.contact-field-hider-widget .app-border-section .title-wrapper .top-text {
    font-weight: bold;
}

.contact-field-hider-widget .action-container .btn {
    margin-left: 15px;
}

.contact-field-hider-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.contact-field-hider-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.contact-field-hider-widget .action-container .btn.transparent-btn {
    background: transparent;
    color: #18aeff;
}

.contact-field-hider-widget .action-container .btn.transparent-btn:hover {
    background: #dbedfa;
}

.contact-field-hider-widget .bordered-container .add svg {
    margin-left: 16px;
}

.contact-field-hider-widget .widget-footer {
    bottom: 0px;
}

.contact-field-hider-widget .selected {
    font-weight: bold;
    color: #382153;
    stroke: #382153;
}

.contact-field-hider-widget .unselected {
    font-weight: bold;
    color: #9b90a9;
}
</style>
